<template>
  <Webview>
    <div class="terms_frame">

      <h1>Sonice Notify 使用者條款</h1>

      <p><strong>生效日期：</strong> 2025 年 MM 月 DD 日</p>

      <p>歡迎使用 <strong>Sonice Notify</strong>（以下簡稱「本應用程式」）。本應用程式由 <strong>好友電智慧科技股份有限公司</strong>（以下簡稱「本公司」）提供。使用本應用程式前，請您詳細閱讀並同意以下使用者條款（以下簡稱「本條款」）。若您不同意本條款，請勿使用本應用程式。</p>

      <h2>1. 接受條款</h2>
      <p>透過下載、安裝或使用本應用程式，即表示您已閱讀、理解並同意受本條款的約束。本公司保留隨時修改本條款的權利，修改後的條款將公佈於本應用程式內或本公司網站上，並於公佈時即生效。建議您定期查閱本條款的最新版本。</p>

      <h2>2. 使用者資格</h2>
      <p>您必須年滿 18 歲，或在您所屬司法管轄區內達到法定成年年齡，並具備簽訂具有法律約束力合約的能力，方可使用本應用程式。若您未滿 18 歲，請在父母或監護人的同意與指導下使用本應用程式。</p>

      <h2>3. 帳號註冊與安全</h2>
      <ul>
        <li><strong>3.1 註冊義務：</strong> 為使用本應用程式的特定功能，您可能需要註冊帳號。您同意提供真實、準確、最新且完整的個人資料。如您的資料有變更，請及時更新。</li>
        <li><strong>3.2 帳號安全：</strong> 您有責任維護帳號及密碼的機密性，並對以您的帳號進行的所有活動負責。如發現未經授權的使用或其他安全問題，請立即通知本公司。本公司對因您未能遵守本條款而導致的任何損失或損害不承擔責任。</li>
      </ul>

      <h2>4. 使用規則</h2>
      <ul>
        <li><strong>4.1 合法使用：</strong> 您同意僅以合法目的使用本應用程式，不從事任何違法、侵權或不當的行為。</li>
        <li><strong>4.2 禁止行為：</strong> 您不得：
          <ul>
            <li>以任何方式干擾或破壞本應用程式的運行或與本應用程式連接的伺服器和網路；</li>
            <li>進行未經授權的訪問、干擾、破壞或破壞本應用程式的任何部分；</li>
            <li>使用本應用程式傳送任何未經請求的商業訊息（垃圾郵件）；</li>
            <li>傳送任何病毒、蠕蟲、惡意軟體或其他有害代碼。</li>
          </ul>
        </li>
      </ul>

      <h2>5. 智慧財產權</h2>
      <p>本應用程式及其內容均屬本公司或其授權者的財產，受著作權法及其他相關法律保護。未經本公司書面許可，您不得以任何形式複製、修改、分發、傳送、展示、執行、重製、出版、授權、創作衍生作品、轉讓或出售上述內容。</p>

      <h2>6. 隱私政策</h2>
      <p>您在使用本應用程式時所提供的個人資料，將依照本公司的隱私政策進行收集、使用、儲存和分享。詳情請參閱本應用程式內的 <strong>隱私政策</strong>。</p>

      <h2>7. 第三方連結</h2>
      <p>本應用程式可能包含指向第三方網站或服務的連結。本公司對其內容、隱私政策或實踐不負責，亦不對因使用第三方網站或服務而產生的任何損害或損失負責。</p>

      <h2>8. 免責聲明</h2>
      <p>本應用程式按「現狀」和「可用性」提供。本公司不對本應用程式的適用性、可靠性、可用性、安全性或無錯誤作出任何保證。</p>

      <h2>9. 責任限制</h2>
      <p>在適用法律允許的最大範圍內，本公司對於因使用或無法使用本應用程式而引起的任何損害不承擔責任。</p>

      <h2>10. 終止</h2>
      <p>本公司保留隨時終止或暫停您訪問本應用程式的權利，無需事先通知。</p>

      <h2>11. 準據法與爭議解決</h2>
      <p>本條款受中華民國（臺灣）法律管轄，並提交臺北地方法院作為第一審管轄法院。</p>

      <h2>12. 條款的可分性</h2>
      <p>若本條款的任何部分被視為無效，其餘部分仍保持有效。</p>

      <h2>13. 完整協議</h2>
      <p>本條款構成您與本公司之間的完整協議，取代先前的所有協議。</p>

      <h2>聯絡我們</h2>
      <p>如有任何疑問，請聯絡我們：</p>
      <p><strong>公司名稱：</strong> 好友電智慧科技股份有限公司</p>
      <p><strong>統一編號：</strong> 94039231</p>
      <p><strong>電子郵件：</strong> <a href="mailto:info@sonice-aioe.com">info@sonice-aioe.com</a></p>

    </div>
  </Webview>
</template>

<script>
export default {

}
</script>

<style>
</style>